import { ToggleButton, ToggleButtonItem } from '@apply/components';
import React from 'react';
import { DashboardClosedByPOCPivotMode } from '../../../../../../constants/DashboardClosedByPOCPivotMode';

export const DashboardClosedByPOCPivotModeToggleButton: React.FC<{
    pivotMode: DashboardClosedByPOCPivotMode;
    set_pivotMode: (mode: DashboardClosedByPOCPivotMode) => void;
}> = ({ pivotMode, set_pivotMode }) => {
    const pivotModes: ToggleButtonItem[] = [
        {
            id: DashboardClosedByPOCPivotMode.Committed,
            text: 'Commitments',
            hint: 'Display Committed Amounts',
        },
        {
            id: DashboardClosedByPOCPivotMode.Number,
            text: 'Number',
            hint: 'Display the Number of Outstanding Loans',
        },
    ];
    return (
        <ToggleButton
            id='byPOCPivotModeToggleButton'
            items={pivotModes}
            selectedItems={[pivotMode]}
            stylingMode='outlined'
            selectionMode='single'
            onItemClick={(e) => set_pivotMode(e?.itemData.id)}
            width='270px'
            height='24px'
            required={true}
        />
    );
};
